import React from 'react';
import { withRouter } from 'react-router';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';

import { Spinner } from 'admin-components/components';
import { GET_BOOKING } from 'store/queries';
import { Redirect } from 'react-router-dom';
import { bookingStatus } from 'types/booking';
import { getBookingJourneysURL, getBookingSearchURL } from 'utils/urls';
import AgentPortalError from 'errors/AgentPortalError';
import { ACTION_CODES } from 'constants/errors';
import { Row, Column } from 'components/shared/Layout';

import BookingPath from './BookingPath';

export const BookingPathQuery = ({
  history,
  location,
  match: {
    params: { reference }
  },
  user: { canAddSpecialAssistanceToBooking }
}) => {
  const membershipNumber = new URLSearchParams(history?.location?.search).get('membershipNumber');

  const { loading, data, refetch, error } = useQuery(GET_BOOKING, {
    variables: { reference },
    fetchPolicy: 'network-only'
  });

  if (loading) {
    return (
      <Row span={16} height="100vh">
        <Column justifyContent="center" alignItems="center">
          <Spinner />
        </Column>
      </Row>
    );
  }

  if (error) {
    throw new AgentPortalError(error, ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE, {
      errorCTARedirect: getBookingSearchURL(membershipNumber)
    });
  }

  if (data.booking.status === bookingStatus.PROVISIONAL) {
    return (
      <BookingPath
        canAddSpecialAssistanceToBooking={canAddSpecialAssistanceToBooking}
        booking={data.booking}
        reference={reference}
        refetch={refetch}
        location={location}
        history={history}
      />
    );
  }

  return <Redirect to={getBookingJourneysURL(reference, membershipNumber)} />;
};

BookingPathQuery.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      reference: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  user: PropTypes.shape({
    canAddSpecialAssistanceToBooking: PropTypes.bool.isRequired
  })
};

export default withRouter(BookingPathQuery);
